import SpriteSymbol from "../../../../node_modules/.pnpm/svg-baker-runtime@1.4.7/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/.pnpm/svg-sprite-loader@4.3.0/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "d2-icon-customize",
  "use": "d2-icon-customize-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"d2-icon-customize\">\n<rect x=\"1.5\" y=\"1.5\" width=\"3\" height=\"13\" rx=\"0.5\" stroke=\"#456BE5\" />\n<rect x=\"6.5\" y=\"1.5\" width=\"3\" height=\"13\" rx=\"0.5\" stroke=\"#456BE5\" />\n<rect x=\"11.5\" y=\"1.5\" width=\"3\" height=\"13\" rx=\"0.5\" stroke=\"#456BE5\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol